import { Component } from '@angular/core';

@Component({
  selector: 'landing-page-login',
  templateUrl: './landing-page-login.component.html',
  styleUrls: ['./landing-page-login.component.css'],
})
export class LandingPageLoginComponent{
    //
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/login/landing-page-login/landing-page-login.component.ts